const appendScript = ({ id, src, async = true, onLoad }) => {
  if (id && document.getElementById(id)) return;

  const script = document.createElement("script");
  if (id) script.id = id;
  script.src = src;
  script.async = async;
  if (onLoad) script.addEventListener("load", onLoad, { once: true });
  document.body.appendChild(script);
};

function loadMeasurement() {
  if (window.__ztAnalyticsLoaded) return;
  window.__ztAnalyticsLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", "G-LNFQ3MHG75");
  appendScript({
    id: "google-analytics",
    src: "https://www.googletagmanager.com/gtag/js?id=G-LNFQ3MHG75",
  });
}

function loadBehaviorAnalytics() {
  if (window.__ztBehaviorAnalyticsLoaded) return;
  window.__ztBehaviorAnalyticsLoaded = true;

  window.clarity = window.clarity || function clarity() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  appendScript({ id: "microsoft-clarity", src: "https://www.clarity.ms/tag/xwi963tbj7" });

  const posthog = (window.posthog = window.posthog || []);
  if (!posthog.__SV) {
    posthog._i = [];
    posthog.init = function init(token, options, name) {
      const instanceName = name || "posthog";
      const instance = name ? (posthog[name] = []) : posthog;
      instance.people = instance.people || [];
      const methods =
        "init capture identify register unregister reset alias set_config startSessionRecording stopSessionRecording".split(
          " ",
        );

      methods.forEach((method) => {
        instance[method] = function queuePostHogCall() {
          instance.push([method].concat(Array.prototype.slice.call(arguments)));
        };
      });

      posthog._i.push([token, options, instanceName]);
    };
    posthog.__SV = 1;

    appendScript({
      id: "posthog-analytics",
      src: "https://us-assets.i.posthog.com/static/array.js",
    });
  }

  posthog.init("phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
    session_recording: {
      recordCrossOriginIframes: true,
      capturePerformance: false,
    },
  });
}

function loadSupportWidgets() {
  if (window.__ztSupportWidgetsLoaded) return;
  window.__ztSupportWidgetsLoaded = true;

  appendScript({
    id: "ze-snippet",
    src: "https://static.zdassets.com/ekr/snippet.js?key=3676e8ad-d9a0-4509-b052-15327b3cd543",
  });
  appendScript({
    id: "respondio__growth_tool",
    src: "https://cdn.respond.io/widget/widget.js?wId=9293c7e8-9420-4801-83f7-bbc2e91e2c47",
  });
}

export function scheduleThirdPartyScripts() {
  const runWhenIdle = (callback, timeout) => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(callback, { timeout });
    } else {
      window.setTimeout(callback, Math.min(timeout, 1000));
    }
  };

  const afterFirstContentfulPaint = () => {
    // Measurement starts after content is visible; session replay and support
    // widgets wait longer because they do substantially more main-thread work.
    window.setTimeout(() => runWhenIdle(loadMeasurement, 3000), 3000);
    window.setTimeout(() => runWhenIdle(loadBehaviorAnalytics, 4000), 8000);

    let supportTimer;
    const loadSupportOnce = () => {
      window.clearTimeout(supportTimer);
      loadSupportWidgets();
    };

    // Chat remains available, but does not compete with the initial render.
    supportTimer = window.setTimeout(loadSupportOnce, 10000);
    window.setTimeout(() => {
      ["pointerdown", "keydown", "touchstart"].forEach((eventName) => {
        window.addEventListener(eventName, loadSupportOnce, { once: true, passive: true });
      });
    }, 5000);
  };

  let scheduled = false;
  const scheduleOnce = () => {
    if (scheduled) return;
    scheduled = true;
    afterFirstContentfulPaint();
  };

  if (performance.getEntriesByName("first-contentful-paint").length) {
    scheduleOnce();
    return;
  }

  if ("PerformanceObserver" in window) {
    const observer = new PerformanceObserver((list) => {
      if (list.getEntries().some((entry) => entry.name === "first-contentful-paint")) {
        observer.disconnect();
        scheduleOnce();
      }
    });
    observer.observe({ type: "paint", buffered: true });
  } else {
    window.setTimeout(scheduleOnce, 12000);
  }
}
